import { render, staticRenderFns } from "./SimulationPage.vue?vue&type=template&id=1d75c7d3&scoped=true&"
import script from "./SimulationPage.vue?vue&type=script&lang=js&"
export * from "./SimulationPage.vue?vue&type=script&lang=js&"
import style0 from "./SimulationPage.vue?vue&type=style&index=0&id=1d75c7d3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d75c7d3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\DigitalCreditTransfer\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1d75c7d3')) {
      api.createRecord('1d75c7d3', component.options)
    } else {
      api.reload('1d75c7d3', component.options)
    }
    module.hot.accept("./SimulationPage.vue?vue&type=template&id=1d75c7d3&scoped=true&", function () {
      api.rerender('1d75c7d3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/administration/SimulationPage.vue"
export default component.exports